import * as React from 'react'
import { SVGProps } from 'react'

const SvgTetherIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#TetherIcon_svg__a)'>
      <path d='M0 0h24v24H0z' />
      <path
        d='M23.641 14.905c-1.603 6.429-8.115 10.342-14.545 8.738C2.67 22.041-1.244 15.528.36 9.1 1.962 2.67 8.473-1.244 14.902.36c6.43 1.603 10.342 8.116 8.739 14.546Z'
        fill='#50AF95'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.52 13.362c-.085.006-.523.033-1.501.033-.778 0-1.33-.024-1.524-.033-3.006-.132-5.25-.656-5.25-1.282 0-.627 2.244-1.15 5.25-1.284v2.045c.196.014.76.047 1.537.047.934 0 1.401-.039 1.485-.046v-2.044c3 .133 5.239.657 5.239 1.282s-2.238 1.148-5.239 1.281l.003.001Zm0-2.776v-1.83h4.186V5.968H6.308v2.79h4.186v1.829c-3.402.156-5.96.83-5.96 1.637 0 .808 2.558 1.481 5.96 1.638v5.863h3.025v-5.865c3.395-.156 5.949-.83 5.949-1.636 0-.807-2.552-1.48-5.949-1.637h.001Z'
        fill='#fff'
      />
    </g>
    <defs>
      <clipPath id='TetherIcon_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)

export default SvgTetherIcon
